import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import parse from 'html-react-parser'
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import Gradiation from '../../../components/ui/gradiation'
import { SectitonWrap, GradiationRow, SectionTitleWrap, StepWrap } from './recruitment-process-area.style'

const RecruitmentProcessArea = ({ titleStyle, subtitleStyle }) => {
    const recruitmentProcessData = useStaticQuery(graphql`
        query recruitmentProcessQuery {
            careersInfoJson(id: {eq: "recruitment-process-content"}) {
                title
                subtitle
                gradiations {
                    id
                    title
                    desc
                }
            }
        }
    `);
    const careersInfoJson = recruitmentProcessData.careersInfoJson;
    if (!careersInfoJson) {
        console.warn("RecruitmentProcessArea: careersInfoJson is null");
        return null;
    }
    const { title, subtitle, gradiations } = careersInfoJson;
    return (
        <SectitonWrap>
            <Container>
                <Row>
                    <Col md={6}>
                        <SectionTitleWrap>
                            {subtitle && <Heading {...subtitleStyle}>{subtitle}</Heading>}
                            {title && <Heading {...titleStyle}>{parse(title)}</Heading>}
                        </SectionTitleWrap>
                    </Col>
                    <Col md={6}>
                        <StepWrap>
                            <h3><mark>{`0${gradiations.length}`}</mark>Steps</h3>
                        </StepWrap>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <GradiationRow>
                            {gradiations.map((gradiation, i) => (
                                <Gradiation
                                    key={gradiation.id}
                                    number={i + 1}
                                    isLast={i === gradiations.length - 1}
                                    title={gradiation.title}
                                    desc={gradiation.desc}
                                />
                            ))}
                        </GradiationRow>
                    </Col>
                </Row>
            </Container>
        </SectitonWrap>
    )
}

RecruitmentProcessArea.defaultProps = {
    titleStyle: {
        as: "h4",
        child: {
            color: 'primary'
        }
    },
    subtitleStyle: {
        as: "h6",
        color: "#333",
        fontSize: '14px',
        letterspacing: '3px',
        texttransform: 'uppercase',
        lineHeight: 1.43,
        mt: '-5px',
        mb: '20px'
    }
}

export default RecruitmentProcessArea
